import { useTranslation } from "react-i18next";

import { ChangeRequestItemDiff } from "~/features/changeRequests/components/ChangeRequestItemDiff";
import type { EvidenceDiffField, EvidenceFieldDiff } from "~/features/evidences/utils/versionDiff";

const FIELD_LABEL_KEY: Record<EvidenceDiffField, string> = {
  properties: "model.common.properties",
  citation: "model.evidence.citation",
  metadata: "model.common.metadata",
};

interface EvidenceVersionDiffProps {
  id: string;
  diffs: EvidenceFieldDiff[];
}

export function EvidenceVersionDiff({ id, diffs }: EvidenceVersionDiffProps) {
  const { t } = useTranslation();

  if (diffs.length === 0) {
    return (
      <p id={id} className="text-fg-3">
        {t("feature.evidences.versionHistory.noChanges")}
      </p>
    );
  }

  return (
    <div id={id} className="flex flex-col gap-3">
      {diffs.map((diff) => (
        <section key={diff.field}>
          <h3 className="mb-2 text-12-bold capitalize text-fg-2">{t(FIELD_LABEL_KEY[diff.field])}</h3>
          <div className="overflow-x-auto rounded-[var(--radius-sm)]">
            <ChangeRequestItemDiff oldValue={diff.oldValue} newValue={diff.newValue} viewMode="detail" />
          </div>
        </section>
      ))}
    </div>
  );
}
